import { useState, createContext, useContext } from "react";
import { handleLoginAuth } from "../api/login";
import { notification } from "antd";
import { userAccount } from "../types/UserAccount";


const UserContext = createContext<any>({});

export const AuthProvider = ({ children }: any) => {
    const [user, setUser] = useState<any>();
    const [collapsed, setCollapsed] = useState(false);


    async function handleLogin(values: userAccount) {
        const resp: any = await handleLoginAuth(values);

        if (resp.data.situation === "authenticated") {
            localStorage.setItem("idUser", resp.data.id);
            localStorage.setItem("token", resp.data.token);
            localStorage.setItem("isAuthenticated", JSON.stringify(true));
            window.location.href = "/inicio";
        } else {
            notification.error({
                message: 'Erro!',
                description: `${resp.data.mensagem}`,
                placement: 'topRight',
                duration: 5
            });
        }
        return resp;
    }

    async function handleLogout() {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('token');
        localStorage.removeItem('expiration');
        // storage.setPermissions([]);
        window.location.href = "/login";
    }

    return (
        <UserContext.Provider value={{ user, setUser, collapsed, setCollapsed, handleLogin, handleLogout }}>
            {children}
        </UserContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('UserContext must be used within a AuthProvider');
    }
    return context;
}